
import React from "react";
import styled from "styled-components";
import { Spin } from "antd";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* Optional: backdrop-filter adds a modern blurred look */
  backdrop-filter: blur(-3px);
`;

interface AppLoaderProps {
  loading: boolean;
  size?: number;
  color?: string;
}

export const AppSpinner: React.FC<AppLoaderProps> = ({
  loading,
  size = 50,
  color = "#914573",
}) => {
  if (!loading) return null;

  return (
    <Overlay>
      <Spin size="large" />
    </Overlay>
  );
};
